<template>
    <div id="withdraw">
        <!-- <div class="top_title fixed">余额提现</div> -->
        <div class="submited" v-if="isSubmit">
            <div class="submited_box">
                <p>提现已申请，可在我的钱包 -> 账务明细中查看进度</p>
                <el-button class="qd" type="primary" @click="gotoAccountDetail">确定</el-button>
            </div>
        </div>
        <div class="un_submit" v-else>
            <div class="bind" v-if="accountList.length > 0">
                <div class="box-item">
                    <img src="../../assets/bx/alipay.png" alt="" />
                    <p>到账支付宝账号</p>
                    <div class="change" @click="changeAccount">切换<i class="icon icon-right"></i></div>
                </div>
                <div class="bind_alipay">
                    <div class="ba_item">
                        <div class="prefix">姓名</div>
                        <div class="info">{{ bindData.name }}</div>
                    </div>
                    <div class="ba_item">
                        <div class="prefix">账号</div>
                        <div class="info">{{ bindData.account | plusX }}</div>
                    </div>
                </div>
                <div class="box-item amount_box">
                    <div class="prefix">提现金额(元)</div>
                    <div class="amount_ipt-area">
                        <span class="yen">&yen;</span>
                        <el-input type="number" class="amount_ipt" placeholder="请输入金额" v-model="amount" @blur="blur" clearable/>
                    </div>
                    <div class="available_amount">
                        可提现余额&nbsp;&yen;&nbsp;{{ available_amount }}
                    </div>
                </div>
                <div class="rules">
                    <p>1、单笔限额10-20000元；单日限额20000</p>
                    <p>2、提现会产生1%服务费，最低2元，向上取整</p>
                    <p>3、默认每日提现次数为3次</p>
                    <p>4、预计<i>次日</i>到账（遇节假日延至工作日）</p>
                </div>
                <div class="amounts">
                    <div class="sj">实际到账：{{ real_amount }}</div>
                    <div class="fw">服务费：{{ service_amount }}</div>
                </div>
                <!-- :disabled="!isApp&&(isAndroid || isPc)" -->
                <el-button class="confirm_recharge" :loading="loading > 0" :disabled="!canSubmit" :class="{'is-disabled': !canSubmit}" @click="cash">确认提现</el-button>
                <!-- <div class="tips" v-if="!isApp&&(isAndroid || isPc)">为了您的操作安全，请下载G买卖交易行APP</div>
                <a href="https://ldy.juhero.cn/ldy/jypt/index.html" target="_blank" style="margin: 1rem 0 2rem;display:block;" v-if="!isApp&&(isAndroid || isPc)">
                    <van-button style="background-color: var(--theme);border:none;
                color:#fff;width: 100%;border-radius: 10rem;height: 3.2rem;font-size: 1.4rem;">前往下载</van-button>
                </a> -->
            </div>
            <div class="unbind" v-else>
                <div class="box-item">
                    <img src="../../assets/bx/alipay.png" alt="" />
                    <p style="color: var(--red)">您尚未绑定支付宝账号</p>
                </div>
                <el-button class="gotobind" type="primary" @click="gotoBind">前往绑定</el-button>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                isSubmit: false,
                bindData: {
                    name: "",
                    account: "",
                },
                showBind: false,
                is_bind: false,
                amount: "",
                real_amount: 0,
                service_amount: 0,
                loading: 0,
                third_img: '',
                accountList: [],
                account_id: '',
                screenWidth: window.innerWidth
            };
        },
        computed: {
            canSubmit() {
                const nameOk = !!(this.bindData && this.bindData.name)
                const amtOk = String(this.amount).trim() !== '' && Number(this.amount) > 0
                return nameOk && amtOk
            },
            isApp() {
                return this.$store.state.isApp
            },
            isPc() {
                return this.$store.getters.ua.isPc
            },
            isAndroid() {
                var u = navigator.userAgent;
                if (u.indexOf("Android") > -1 || u.indexOf("Adr") > -1) {
                    return true
                } else {
                    return false
                }
            },
            isiOS() {
              var u = navigator.userAgent;
              if(!!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
                return true
              }else {
                return false
              }
            },
            available_amount() {
                return this.$store.state.userData&&this.$store.state.userData.balance
            },
        },
        filters: {
            plusX(str) {
                var x = "****";
                if (str.length >= 6) {
                    return (
                        str.substring(0, 3) + x + str.substring(str.length - 4, str.length)
                    );
                } else {
                    return str;
                }
            },
        },
        created() {
            this.checkAccountInfo();
        },
        mounted() {
            var that = this
            window.addEventListener('resize', () => { that.screenWidth = window.innerWidth })
        },
        methods: {
            blur() {
                if (this.amount != "") {
                    if (this.amount <= 0) {
                        this.$toast("请填写正确的金额");
                        return;
                    } else {
                        var reg = /^(-?\d+)(\.\d{1,2})?$/;
                        if (reg.test(this.amount)) {
                            if (Number(this.amount) > Number(this.available_amount)) {
                                this.$toast("提现金额不能大于可用余额");
                                this.amount = ""
                                return;
                            }
                            this.$Ajax(
                                "wallet/get-real-amount", {
                                    amount: this.amount,
                                    otype: 1
                                },
                                "get"
                            ).then(rs => {
                                if (rs.code == 200) {
                                    this.real_amount = rs.data.real_amount;
                                    this.service_amount = rs.data.service_amount;
                                }
                            });
                        } else {
                            this.$toast("提现金额最多两位小数");
                        }
                    }
                }else {
                    this.real_amount = 0
                    this.service_amount = 0
                }
            },
            gotoAccountDetail() {
                this.$router.replace({
                    name: "account.detail",
                });
            },
            //查询收款账户
            async checkAccountInfo() {
                await this.$Ajax("wallet/recv-account-info", {}, "get").then(rs => {
                    this.showBind = true;
                    if (rs.code == 200) {
                        this.accountList = rs.data
                        if (rs.data.length > 0) {
                            if(this.$route.query.id) {
                                this.account_id = this.$route.query.id
                                this.bindData.name = rs.data.find(item => item.id == this.account_id).name
                                this.bindData.account = rs.data.find(item => item.id == this.account_id).account
                                this.third_img = rs.data.find(item => item.id == this.account_id).third_img
                                this.account_id = rs.data.find(item => item.id == this.account_id).id
                            }else {
                                this.bindData.name = rs.data[0].name;
                                this.bindData.account = rs.data[0].account;
                                this.third_img = rs.data[0].third_img;
                                this.account_id = rs.data[0].id;
                            }
                        }
                        // this.bindData.name = rs.data.name;
                        // this.bindData.account = rs.data.account;
                        // if (rs.data.account == "") {
                        //     this.is_bind = false;
                        // } else {
                        //     this.is_bind = true;
                        //     if (rs.data.third_img == "") {
                        //         this.$RModal.tip({
                        //             selection: {
                        //                 topTitle: '温馨提示',
                        //                 title: `为确保您的信息正确，请截\n图支付宝个人主页界面上传`,
                        //                 btn: "去上传",
                        //             },
                        //             onSuccess: () => {
                        //                 this.$router.push({
                        //                     name: "bind.account",
                        //                     query: {
                        //                         action: 'modify',
                        //                     },
                        //                 });
                        //             },
                        //         });
                        //     } else {
                        //         this.third_img = rs.data.third_img
                        //     }
                        // }
                        this.$forceUpdate()
                    }
                });
            },
            //提现
            cash() {
                if (!this.canSubmit) return
                if (this.third_img == '') {
                    this.$RModal.tip({
                        selection: {
                            topTitle: '温馨提示',
                            title: `为确保您的信息正确，请截\n图支付宝个人主页界面上传`,
                            btn: "去上传",
                        },
                        onSuccess: () => {
                            this.$router.push({
                                name: "bind.account",
                                query: {
                                    action: 'modify',
                                },
                            });
                        },
                    });
                    return
                }
                if (this.amount == "") {
                    this.$toast("请填写提现金额");
                    return;
                } else {
                    if (Number(this.amount) < 10 || Number(this.amount) > 20000) {
                        this.$toast("单笔限额10-20000元");
                        return;
                    }
                }
                if(this.screenWidth > 750) {
                    this.$toast("请前往手机端或APP进行提现");
                    return;
                }
                this.loading++;
                // this.$Ajax("user-info/certification", {
                //     otype: 1,
                //     action: 'withdrawal'
                // })
                // .then(rs => {
                //     if (rs.code == 200) {
                //         localStorage.setItem('cashout_params', JSON.stringify({
                //             certifyId: rs.data.certifyId,
                //             account: this.bindData.account,
                //             name: this.bindData.name,
                //             amount: this.amount,
                //             alipay_img: this.third_img
                //         }))
                //         this.callcertify(rs.data.certifyId);
                        
                //     }
                // })
                // .finally(() => {
                //     setTimeout(() => {
                //         this.loading = 0;
                //     }, 2000);
                // });
                this.$Ajax("wallet/cash", {
                    recv_account_id: this.account_id,
                    account: this.bindData.account,
                    name: this.bindData.name,
                    amount: this.amount,
                    alipay_img: this.third_img
                })
                .then(rs => {
                    if (rs.code == 200) {
                        setTimeout(() => {
                            this.isSubmit = true;
                        }, 2000);
                    }
                })
                .finally(() => {
                    setTimeout(() => {
                        this.loading = 0;
                    }, 2000);
                });
            },
            callcertify(certifyId) {
                var _that = this;
                this.$Ajax("user-info/call-certify", { certifyId }).then(rs => {
                if (rs.code == 200) {
                    _that.certifyUrl =  'alipays://platformapi/startapp?appId=20000067&url=' + encodeURIComponent(rs.data.certifyUrl)
                    setTimeout(() => {
                      window.location.href = _that.certifyUrl
                    },300)
                  }
                });
            },
            //前往绑定账号
            gotoBind() {
                this.$router.push({
                    name: "bind.account",
                });
            },
            changeAccount() {
                var that = this
                this.$filterPop({
                    type: 'alipayaccounts',
                    direction: 'up',
                    selection: {
                        accountList: this.accountList,
                        account_id: this.account_id,
                    },
                    onSuccess: (data) => {
                        this.account_id = data.account_id;
                        this.bindData.account = that.accountList.filter((item) => item.id == data.account_id)[0].account;
                        this.bindData.name = that.accountList.filter((item) => item.id == data.account_id)[0].name;
                        this.third_img = that.accountList.filter((item) => item.id == data.account_id)[0].third_img;
                        this.$forceUpdate()
                    }
                })
            },
        }
    };
</script>
<style lang="less" scoped>
    #withdraw {
        padding-top: 1rem;
        .submited {
            .submited_box {
                background-color: #fff;
                border-radius: 0.6rem;
                padding: 1.4rem 0;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                p {
                    margin-bottom: 4rem;
                    font-size: 1.4rem;
                }

                .qd {
                    height: 2.8rem;
                    width: 10rem;
                    border-radius: 10rem;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 1.2rem;
                }
            }
        }

        //bind
        .box-item {
            background-color: #fff;
            display: flex;
            align-items: center;
            height: 3.6rem;
            padding: 0 1.6rem;
            border-radius: 0.6rem;
            font-size: 1.4rem;
            position: relative;
            img {
                width: 1.85rem;
                height: 1.85rem;
                margin-right: 0.6rem;
            }

            .prefix {
                width: 6.8rem;
            }

            /deep/.amount_ipt {
                border: none;
                .el-input__inner {
                    border: none;
                    color: #000;
                    font-size: 1.6rem;
                }
            }
            .change {
                position: absolute;
                right: .9rem;
                top: 50%;
                transform: translateY(-50%);
                font-size: 1.4rem;
                color: #a4a4a4;
                cursor: pointer;
                .icon-right {
                    margin-left: .5rem;
                    display: inline-block;
                    border-right: 1px solid #a4a4a4;
                    border-bottom: 1px solid #a4a4a4;
                    width: 0.7rem;
                    height: 0.7rem;
                    border-radius: 0.1rem;
                    transform: translateY(-0.1rem) rotate(-45deg);
                }
            }
            &.amount_box {
                display: block;
                padding: 1.3rem 1rem 1.6rem;
                margin-bottom: 1.4rem;
                height: auto;
                .prefix {
                    width: 100%;
                    color: #000;
                    margin-bottom: 1.2rem;
                }
                .amount_ipt-area {
                    display: flex;
                    align-items: center;
                    border-bottom: 1px solid #f2f2f2;
                    padding-left: .7rem;
                    margin-bottom: .8rem;
                    .yen {
                        font-size: 1.4rem;
                        color: #000;
                        transform: translateY(0.2rem);
                    }
                }
                .available_amount {
                    font-size: 1.2rem;
                    color: #a4a4a4;
                    padding-left: .7rem;
                }
            }
        }

        .bind_alipay {
            border-radius: 0.6rem;
            overflow: hidden;
            background-color: #fff;
            margin: 1.2rem 0;

            .ba_item {
                height: 4.4rem;
                display: flex;
                align-items: center;
                padding: 0 1.6rem;
                color: #000;
                font-size: 1.4rem;

                .prefix {
                    width: 6.8rem;
                }
            }
        }

        .rules {
            margin: 2rem 0 1.6rem;
            line-height: 2.2rem;

            i {
                color: var(--warning);
            }
        }

        .amounts {
            display: flex;
            margin-bottom: 3rem;

            .sj {
                width: 13rem;
            }
        }

        .confirm_recharge {
            background-color: #F66F30;
            border-color: #F66F30;
            height: 3.9rem;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 10rem;
            font-size: 1.4rem;
            color: #fff;
            &:active {
                opacity: 0.9;
            }
            &:disabled,
            &.is-disabled {
                background-color: #a4a4a4;
                border-color: #a4a4a4;
                pointer-events: none;
                cursor: not-allowed !important;
                &:active {
                    opacity: 1;
                }
            }
        }

        .gotobind {
            height: 3rem;
            border-radius: 10rem;
            width: 12rem;
            font-size: 1.4rem;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 4rem auto 0;
        }
    }
    .tips {
        color: var(--red);
        margin-top: 1rem;
        text-align: center;
    }
    .amount_ipt {
        /deep/ .el-input__clear {
            color: transparent;
            background: url(../../assets/bx/clear.png) no-repeat center center;
            background-size: 1.4rem 1.4rem;
        }
    }
    .qr_close {
  z-index: 100;
  position: fixed;
  top: 36rem;
  right: -2rem;
  width: 4rem;
  height: 4rem;
  background-color: rgba(153, 153, 153,0.5);
  border-radius: 50%;
  cursor: pointer;
  .arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0.2rem;
    font-size: 2rem;
  }
}
.qr_open {
  z-index: 100;
  position: fixed;
  top: 32rem;
  right: -1.2rem;
  background-color: rgba(153, 153, 153,0.5);
  width: 12rem;
  height: 12rem;
  border-top-left-radius: 1.6rem;
  border-bottom-left-radius: 1.6rem;
  color: var(--theme);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-right: 0.4rem;
  &::before{
    content: "";
    position: absolute;
    left: -1.2rem;
    top: 50%;
    transform: translateY(-50%);
    width: 4rem;
    height: 4rem;
    border-radius: 50%;
    background: linear-gradient(to right, rgba(153, 153, 153,0.5) 0%,rgba(153, 153, 153,0.5) 30%,transparent 30.1%,transparent 100%);
    cursor: pointer;
  }
  .arrow {
    position: absolute;
    left: -1rem;
    top: 50%;
    transform: translateY(-50%);
    font-size: 2rem;
    cursor: pointer;
  }
  .qrcode {
    width: 8rem;
    height: 8rem;
    background-color: #fff;
    margin-top: 1.2rem;
    margin-bottom: 0.5rem;
    /deep/img,
    /deep/canvas {
      width: 100%;
      height: 100%;
    }
  }
  a {
    color: var(--theme);
    font-size: 1.2rem;
  }
}
</style>
